import { network } from 'services/network';

import { QueryParams, QueryResponse } from 'api/queries/getCriticalityWeightScurveGraph.query';

export const ENDPOINT = 'api/bo/getProgressScurveGraph';

export const getProgressScurveGraph = (params: QueryParams): Promise<QueryResponse> => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
